import { gql } from "@apollo/client";

export const GET_COMPANIES = gql`
  query companies($search: String) {
    companies(first: 1000) {
      edges {
        node {
          id
          name
          sites(search: $search) {
            edges {
              node {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;

export const DUPLICATE_EXPERIENCE = gql`
  mutation DuplicateExperience(
    $experienceId: ExperienceID!
    $destinationSiteId: SiteID!
  ) {
    duplicateExperience(
      experienceId: $experienceId
      destinationSiteId: $destinationSiteId
    )
  }
`;

export const SEARCH_ORGANISATION = gql`
  query companies($search: String, $first: Int!) {
    companies(first: $first) {
      edges {
        node {
          id
          name
          sites(search: $search) {
            edges {
              node {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;
